/*
 ガン検診
 */
import api from './api'

const cancerexamSection = {
	name: 'cancerexam-section',
	delimiters: ['${', '}'],
	template: '#v-cancerexam-section',
	props: ['cancerexam', 'institutions'],
	data () {
		return {
			opened: false
		}
	},
	methods: {
		getServiceName (id) {
			return this.services ? this.services[id].service_name : ''
		},
		open () {
			this.opened = true
		},
		close () {
			this.opened = false
		},
		toggle () {
			this.opened = !this.opened
		}
	}
}

export default function cancerexam () {

	const myapp = new Vue({
		delimiters: ['${', '}'],
		el: '#v-cancerexam',
		components: {cancerexamSection},
		data () {
			return {
				cancerexams: null,
				institutions: null,
			}
		},
		computed: {
			/*
				検診ごとのに分ける
				[
					{cancerexam, institutions}, ...
				]
			*/
			cancerexamInstitutions () {
				if (!this.cancerexams || !this.institutions) {
					return
				}
				const rows = {}
				this.institutions.forEach(institution => {
					if (institution.cancers) {
						institution.cancers.split(',').forEach(examId => {
							if (!rows[examId]) {
								rows[examId] = []
							}
							rows[examId].push(institution)
						})
					}
				})
				return Object.values(this.cancerexams).map(cancerexam => {
					const institutions = rows[cancerexam.id]
					return {cancerexam, institutions}
				}).filter(row => row.institutions)
			}
		},
		methods: {
		},
		created () {
			api.institutions.cancer().then(data => {
				this.cancerexams = data
			})
			api.institutions({order: 2}).then(data => {
				this.institutions = data
			})
		},
		mounted () {
		}
	})

}